<template>
  <div class="jd-mobile-bar hp-show-mobile" v-if="job && !loading">
    <JobDetailApply
      :job="job"
      :applied="applied"
      :expired="expired"
      :q-result="qResult"
      :has-questionnaire="hasQuestionnaire"
      :error="error"
      :err-msg="errMsg"
      compact
      @apply="$emit('apply')"
    />
    <button type="button" class="hp-btn hp-btn--outline jd-mobile-bar__share" @click="$emit('share')" aria-label="Copy link">
      <v-icon size="18">{{ $icons.link }}</v-icon>
    </button>
  </div>
</template>

<script>
import JobDetailApply from '@/components/job/JobDetailApply.vue';

export default {
  name: 'JobDetailMobileBar',
  components: { JobDetailApply },
  props: {
    job: { type: Object, default: null },
    loading: { type: Boolean, default: true },
    applied: { type: Boolean, default: false },
    expired: { type: Boolean, default: false },
    qResult: { type: Number, default: 0 },
    hasQuestionnaire: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    errMsg: { type: String, default: null },
  },
};
</script>
